import { ROUTE_SPORTSBOOK, ROUTE_LIVEBETTING, ROUTE_SPORTSBOOK_EXPLORE_PAGE } from '../router/constants.js';

export const PRODUCT_SPORTSBOOK = 'sportsbook';
export const PRODUCT_LIVEBETTING = 'livebetting';
export const PRODUCT_PAYMENTS = 'payments';

const LAST_PRODUCT_COOKIE_SPORTSBOOK = 'sportsbook';
const LAST_PRODUCT_COOKIE_LIVEBETTING = 'live-betting';

export const ROUTE_TO_PRODUCT_MAP = {
	[ROUTE_SPORTSBOOK]: PRODUCT_SPORTSBOOK,
	[ROUTE_LIVEBETTING]: PRODUCT_LIVEBETTING
};

export const PRODUCT_TO_ROUTE_MAP = {
	[PRODUCT_SPORTSBOOK]: ROUTE_SPORTSBOOK_EXPLORE_PAGE,
	[PRODUCT_LIVEBETTING]: ROUTE_LIVEBETTING
};

export const ROUTE_TO_LAST_PRODUCT = {
	[ROUTE_SPORTSBOOK]: LAST_PRODUCT_COOKIE_SPORTSBOOK,
	[ROUTE_LIVEBETTING]: LAST_PRODUCT_COOKIE_LIVEBETTING
};

export const PRODUCT_TO_LAST_PRODUCT = {
	[PRODUCT_SPORTSBOOK]: LAST_PRODUCT_COOKIE_SPORTSBOOK,
	[PRODUCT_LIVEBETTING]: LAST_PRODUCT_COOKIE_LIVEBETTING
};
